import { Injectable } from '@angular/core';
import { HttpHandler, HttpRequest, HttpInterceptor, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/internal/operators';
import { LogService } from './log.service';
import { endpoints } from 'src/assets/server/endpoints';

@Injectable({
  providedIn: 'root'
})
/**
 * @Description this is an interceptor for handling errors
 * @date 2020-11-03
 * @param {any} logService :LogService
 * @returns void
 */
export class HttpErrorInterceptor implements HttpInterceptor {
  /**
   * @description Constructor
   * @params logService
   */
  constructor(private logService: LogService) {
    this.logService = logService;
   }
/**
 * @description intercept
 * @params req
 * @params next
 */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(error => {
        let errorMessage = '';
        if (error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Client-side error: ${error.error.message}`;
        } else {
          // El codigo se escribe sin template strings, porque sino se viola una regla de kiuwan
          errorMessage = 'Server-side error: ' + error.status + ' ' + error.message;
        }
        this.logService.traceError(errorMessage);
        if (req.url.includes(endpoints.presupuestoGuardar.name)) {
          const fakeResponse = new HttpResponse({
            body: error.error,
            status: 200, // Cambiar estado a 200
            statusText: 'OK',
            url: error.url || req.url
          });
          return of(fakeResponse);
        }
        return throwError(errorMessage);
      })
    );
  }
}
